// @flow

import React, { type Node } from 'react';
import Display from './Display';
import Headline from './Headline';

type Props = {
  children?: Node,
  /**
   * Text to render as the Display component children
   */
  display?: Node,
  /**
   * Text to render as the Headline component children
   */
  headline?: Node
};

const DISPLAY_NAME = 'ListContent';

export default function ListContent(props: Props) {
  const { children, display, headline, ...other } = props;

  return (
    <div {...other}>
      {display && <Display>{display}</Display>}
      {headline && <Headline>{headline}</Headline>}
      {children}
    </div>
  );
}
ListContent.displayName = DISPLAY_NAME;



// WEBPACK FOOTER //
// ./js/AppStructure/ListContent.js